import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApprovalService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getSupportRequests(status: any, userKeyID: number) {
    var url = "/Approval/GetSupportRequests?supportDepartmentID=" + null
      + "&status=" + status + "&userKeyID=" + userKeyID
    return this.http.get(url).toPromise();
  }

  getHRList(searchText?: string, includeInactive?: string, userKeyID?: number) {
    var url = "/Approval/GetHRList?searchText="+ searchText + "&includeInactive=" + includeInactive + "&userKeyID=" + userKeyID;
    return this.http.get(url).toPromise();
  }

  updateRequest(supportRequestID: number, supportDepartmentID: number, requestStatus: string, assignedToUserKeyID: number, submittedByUserKeyID: number, isUrgent: boolean) {
    return this.http.post("/Approval/UpdateRequest", {
      supportRequestID: supportRequestID,
      supportDepartmentID: supportDepartmentID,
      requestStatus: requestStatus,
      assignedToUserKeyID: assignedToUserKeyID,
      submittedByUserKeyID: submittedByUserKeyID,
      isUrgent: isUrgent
    }).toPromise();
  }

  getRequestByID(supportRequestID: number) {
    var url = "/Approval/GetRequestByID?supportRequestID=" + supportRequestID;
    return this.http.get(url).toPromise();
  }

  getSupportNotes(supportRequestID: number) {
    var url = "/Approval/GetSupportNotes?supportRequestID=" + supportRequestID;
    return this.http.get(url).toPromise();
  }

  addSupportNote(supportRequestID: number, supportNote: string, isNotify: boolean) {
    return this.http.post("/Approval/AddSupportNote", {
      supportRequestID: supportRequestID,
      supportNote: supportNote,
      isNotify: isNotify
    }).toPromise();
  }

  getAssestsByEmployee(supportRequestID: number) {
    var url = "/Approval/GetAssestsByEmployee?supportRequestID=" + supportRequestID;
    return this.http.get(url).toPromise();
  }

  getAttachmentsByRequestID(supportRequestID: number) {
    var url = "/Approval/GetAttachmentsByRequestID?moduleID=" + 13 + "&recordID=" + supportRequestID;
    return this.http.get(url).toPromise();
  }

  dependentRequestAction(dependentRequestID: number, postData: any, actionCode: string, actionNotes: any) {
    return this.http.post("/Approval/DependentRequestAction",
      {
        dependentRequestID: dependentRequestID,
        formData: postData,
        actionCode: actionCode,
        actionNotes: actionNotes
      }).toPromise();
  }
  saveWindowAuditReportData(benefitUserWindowID: number){
    return this.http.post("/Approval/SaveWindowAuditReportData",
      {
        benefitUserWindowID: benefitUserWindowID
      }).toPromise();
  }
  getWindowHistory(hRUserKeyID: number){
    var url = "/Approval/GetWindowHistory?hRUserKeyID=" + hRUserKeyID;
    return this.http.get(url).toPromise();
  }
}